import Vue from 'vue'
import Router from 'vue-router'
import ttSAPLink from '../views/SAP-Display'
import ttNODATA from '../views/SAP-NODATA'
import ttform from '../views/POD-Form'
// import store from '../store/index'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/nodata',
      name: 'tt-saplink-default',
      component: ttNODATA
    },
    {
      path: '/search',
      name: 'tt-saplink-search',
      component: ttform
    },
    {
      path: '/',
      name: 'tt-saplink',
      component: ttSAPLink,
      beforeEnter: (to, from, next) => {
        if (!hasQueryParams(to) && hasQueryParams(from)) {
          next({ name: to.name, query: from.query })
        } else {
          next()
        }
      }
    }
  ]
})

function hasQueryParams (route) {
  return !!Object.keys(route.query).length
}
